import React, { useState, useEffect } from "react";
import "./timer.styles.scss";
import duration from "dayjs/plugin/duration";
import dayjs from "dayjs";
import { Tag } from "antd";
dayjs.extend(duration);
interface ITimer {
  time: string;
  saudha?: boolean;
  buffer?: boolean;
}

const Timer: React.FC<ITimer> = (props: ITimer) => {
  const { time, saudha = false, buffer = false } = props;
  const [remainigTime, setRemainingTime] = useState("");

  const msToTime = (s: number) => {
    const pad = (n: number) => {
      return n < 10 ? "0" + n : n;
    };
    var ms: number = s % 1000;
    s = (s - ms) / 1000;
    var secs: number = s % 60;
    s = (s - secs) / 60;
    var mins: number = s % 60;
    var hrs: number = (s - mins) / 60;

    return pad(hrs) + ":" + pad(mins) + ":" + pad(secs);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const now = dayjs(dayjs(), "HH:mm:ss", true);
      let then = dayjs(time, "HH:mm:ss", true);

      if (then.isBefore(now)) {
        then = then.add(1, "day");
      }
      if (saudha && then.isBefore(now)) {
        clearInterval(interval);
      }
      var duration = dayjs.duration(then.diff(now));
      var hours = duration.asMilliseconds();
      setRemainingTime(msToTime(hours));
    }, 1000);
    return function cleanup() {
      clearInterval(interval);
    };
  }, [time]);

  return (
    <Tag color={"warning"} style={{ fontSize: 16 }}>
      {!saudha
        ? `${
            buffer ? "Remaining Buffer Time" : "Remaining Time"
          }: ${remainigTime}`
        : `${remainigTime}`}
    </Tag>
  );
};

export default Timer;
